import { AnyAction } from 'redux';
import { ActionTypesPrePayClaimsPage, InitialStatePrePayClaimsPage } from './constants';
import {
  PrepayClaimHeaderType,
  PrepayClaimMemberType,
  PrepayClaimPatientType,
  PrepayClaimsPageStateType,
} from './types';

export const initialState: PrepayClaimsPageStateType = {
  isEditMode: false,
  isGlobalSearch: false,
  claimLineGridData: [],
  claimPatientGridData: {} as PrepayClaimPatientType,
  claimMemberGridData: {} as PrepayClaimMemberType,
  claimHeaderDetails: {} as PrepayClaimHeaderType,
  isClaimLinesLoading: false,
  providerData: [],
  isProviderLoading: false,
  isClaimHeaderLoading: false,
  isClaimCustomNotesLoading: false,
  isClaimAttachmentsLoading: false,
  isClaimInvoiceActivitiesLoading: false,
  isDetailPaneLoading: false,
  attachmentsData: [],
  caseSearchData: [],
  appealsOfClaimIdData: [],
  isAppealsOfClaimIdLoading: false,
  breadCrumbItemsDetailPane: [],
  claimInvoiceActivitiesData: [],
  claimRoutingData: [],
  claimOperations: [],
  isClaimRoutingLoading: false,
  isClaimOperationsActionLoading: false,
  createInquiryLookUpdata: null,
  isCreateInquiryLookUpdataLoading: false,
  isCreatePortalEorLoading: false,
  eorVersionsData: [],
  isEorVersionsLoading: false,
  inquiryIdCreated: 0,
  isCreateInquirySaveComplete: false,
  isUpdateInquiryComplete: false,
  isUpdateInquiryLoading: false,
  clientNetworks: [],
  clientServices: [],
  isAdjustSavingDropdownLoading: false,
  isAdjustSavingsLoading: false,
  adjustmentStatuses: [],
  adjustmentReasons: [],
  isClaimActivityInfoLoading: false,
  claimActivityInfoData: [],
};

const prepayClaimsPageReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    /* * * * * * * * * * * * * * * * * * * *
        PrepayClaims PAGE WRAPPER REDUCERS
    * * * * * * * * * * * * * * * * * * * */

    case ActionTypesPrePayClaimsPage.SET_PREPAY_CLAIM_LINES_GRID_DATA:
      return {
        ...state,
        claimLineGridData: action.gridData,
      };
    case ActionTypesPrePayClaimsPage.SET_PREPAY_CLAIM_HEADER_DETAILS:
      return {
        ...state,
        claimHeaderDetails: action.claimHeaderDetails,
      };
    case ActionTypesPrePayClaimsPage.SET_PREPAY_CLAIM_PATIENT_MEMBER_DATA:
      return {
        ...state,
        claimPatientGridData: action.claimPatientGridData,
        claimMemberGridData: action.claimMemberGridData,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_CLAIM_LINES_LOADING:
      return {
        ...state,
        isClaimLinesLoading: action.isClaimLinesLoading,
      };
    case ActionTypesPrePayClaimsPage.SET_PROVIDER_DATA:
      return {
        ...state,
        providerData: action.gridData,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_PROVIDER_LOADING:
      return {
        ...state,
        isProviderLoading: action.isProviderLoading,
      };

    case ActionTypesPrePayClaimsPage.TOGGLE_CLAIM_HEADER_LOADING:
      return {
        ...state,
        isClaimHeaderLoading: action.isClaimHeaderLoading,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_CLAIM_PATIENT_MEMBER_LOADING:
      return {
        ...state,
        isClaimPatientMemberLoading: action.isClaimPatientMemberLoading,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_CLAIM_CUSTOM_NOTES_LOADING:
      return {
        ...state,
        isClaimCustomNotesLoading: action.isClaimCustomNotesLoading,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_CLAIM_ATTACHMENTS_LOADING:
      return {
        ...state,
        isClaimAttachmentsLoading: action.isClaimAttachmentsLoading,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_CREATE_PORTAL_EOR_LOADING:
      return {
        ...state,
        isCreatePortalEorLoading: action.isCreatePortalEorLoading,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_DETAIL_PANE_LOADING:
      return {
        ...state,
        isDetailPaneLoading: action.isDetailPaneLoading,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_INVOICE_ACTIVITIES_LOADING:
      return {
        ...state,
        isClaimInvoiceActivitiesLoading: action.isInvoiceActivitiesLoading,
      };
    case ActionTypesPrePayClaimsPage.SET_PREPAY_CLAIM_ATTACHMENTS_DATA:
      return {
        ...state,
        attachmentsData: action.gridData,
      };
    case ActionTypesPrePayClaimsPage.SET_PREPAY_CLAIM_SEARCH_DATA:
      return {
        ...state,
        caseSearchData: action.data,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_APPEALS_OF_CLAIMID_LOADING:
      return {
        ...state,
        isAppealsOfClaimIdLoading: action.isLoading,
      };
    case ActionTypesPrePayClaimsPage.SET_APPEALS_OF_CLAIMID_DATA:
      return {
        ...state,
        appealsOfClaimIdData: action.gridData,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_INQUIRIES_OF_CLAIMID_LOADING:
      return {
        ...state,
        isInquiriesOfClaimIdLoading: action.isLoading,
      };
    case ActionTypesPrePayClaimsPage.SET_INQUIRIES_OF_CLAIMID_DATA:
      return {
        ...state,
        inquiriesOfClaimIdData: action.gridData,
      };
    case ActionTypesPrePayClaimsPage.CLEAR_PREPAY_CLAIM_DETAIL_PANE_REDUX_DATA:
      return {
        ...state,
        ...InitialStatePrePayClaimsPage,
      };
    case ActionTypesPrePayClaimsPage.SET_PREPAY_CLAIMS_DETAIL_PANE_BREADCRUMB_ITEMS:
      return {
        ...state,
        breadCrumbItemsDetailPane: action.breadCrumbItems,
      };
    case ActionTypesPrePayClaimsPage.SET_PREPAY_CLAIM_INVOICE_ACTIVITIES_DATA:
      return {
        ...state,
        claimInvoiceActivitiesData: action.gridData,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_INQUIRY_CREATE_LOOPKUP_LOADING:
      return {
        ...state,
        isCreateInquiryLookUpdataLoading: action.isLoading,
      };
    case ActionTypesPrePayClaimsPage.SET_INQUIRY_CREATE_LOOPKUP_DATA:
      return {
        ...state,
        createInquiryLookUpdata: action.lookupData,
      };
    case ActionTypesPrePayClaimsPage.SET_EOR_VERSIONS_DATA:
      return {
        ...state,
        eorVersionsData: action.data,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_EOR_VERSIONS_LOADING:
      return {
        ...state,
        isEorVersionsLoading: action.isEorVersionsLoading,
      };
    case ActionTypesPrePayClaimsPage.CLEAR_EOR_VERSIONS_DATA:
      return {
        ...state,
        eorVersionsData: [],
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_INQUIRY_CREATE_LOADING:
      return {
        ...state,
        isCreateInquirySaveComplete: action.isComplete,
        inquiryIdCreated: action.inquiryId,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_INQUIRY_UPDATE_COMPLETE:
      return {
        ...state,
        isUpdateInquiryComplete: action.isComplete,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_INQUIRY_UPDATE_LOADING:
      return {
        ...state,
        isUpdateInquiryLoading: action.isLoading,
      };
    case ActionTypesPrePayClaimsPage.SET_ADJUST_SAVING_CLIENT_DROPDOWNS:
      return {
        ...state,
        clientNetworks: action.clientNetworks,
        clientServices: action.clientServices,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_ADJUST_SAVINGS_DROPDOWN_LOADING:
      return {
        ...state,
        isAdjustSavingDropdownLoading: action.isLoading,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_ADJUST_SAVINGS_LOADING:
      return {
        ...state,
        isAdjustSavingsLoading: action.isLoading,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_IS_CLAIM_ROUTING_LOADING:
      return {
        ...state,
        isClaimRoutingLoading: action.isLoading,
      };
    case ActionTypesPrePayClaimsPage.TOGGLE_IS_CLAIM_OPERATIONS_ACTION_LOADING:
      return {
        ...state,
        isClaimOperationsActionLoading: action.isLoading,
      };
    case ActionTypesPrePayClaimsPage.SET_CLAIM_ROUTING_INFO:
      return {
        ...state,
        claimRoutingData: action.claimRoutingData,
        claimOperations: action.claimOperations,
      };
    case ActionTypesPrePayClaimsPage.SET_ADJUSTMENT_DROPDOWNS:
      return {
        ...state,
        adjustmentStatuses: action.adjustmentStatuses,
        adjustmentReasons: action.adjustmentReasons,
      };
    case ActionTypesPrePayClaimsPage.SET_CLAIM_ACTIVITY_INFO_DATA:
      return {
        ...state,
        claimActivityInfoData: action.data,
      };

    case ActionTypesPrePayClaimsPage.TOGGLE_CLAIM_ACTIVITY_INFO_LOADING:
      return {
        ...state,
        isClaimActivityInfoLoading: action.isLoading,
      };
    case ActionTypesPrePayClaimsPage.SET_CLAIMS_GRID_COLUMN_CONFIG:
      return {
        ...state,
        claimsGridColumnConfig: action.payload,
      };
    // case ActionTypesPrePayClaimsPage.SET_INQUIRY_CREATE_DATA:
    //   return {
    //     ...state,
    //     inquiryIdCreated: action.inquiryId,
    //   };
    default:
      return state;
  }
};

export default prepayClaimsPageReducer;
